export default {
  'common.operation': 'Operación',
  'product.management.title': 'Gestión de Productos',
  'product.management.add': 'Añadir Producto',
  'product.management.edit': 'Editar Producto',
  'product.management.delete': 'Eliminar',
  'product.management.search': 'Consultar',
  'product.management.reset': 'Restablecer',
  'product.management.name': 'Nombre del Producto',
  'product.management.type': 'Tipo de Producto',
  'product.management.status': 'Estado',
  'product.management.currency': 'Moneda',
  'product.management.value': 'Valor del Producto',
  'product.management.amount': 'Cantidad de Producto',
  'product.management.price': 'Puntos del Producto',
  'product.management.quantity': 'Cantidad de Producto',
  'product.management.limit': 'Límite de Compra',
  'product.management.dailyLimit': 'Límite de Compra Diaria',
  'product.management.vipLimit': 'Límite de Compra',
  'product.management.vipLimitDisplay': 'VIP {{value}}',
  'product.management.vipPurchaseLimit': 'Límite de Compra VIP',
  'product.management.vipPurchaseLimitCount': 'Cantidad de Límite de Compra',
  'product.management.vipPurchaseLimitEnabled': 'Habilitado',
  'product.management.vipLevel': 'VIP',
  'product.management.vipLimitZeroError': 'El límite de compra del nivel VIP habilitado no puede ser 0',
  'product.management.sort': 'Ordenar',
  'product.management.flow': 'Flujo de Producto',
  'product.management.cash': 'Efectivo',
  'product.management.props': 'Accesorios',
  'product.management.propsCategory': 'Categoría de Accesorios',
  'product.management.propsCategory.luckySpin': 'Boleto de Giros de Suerte',
  'product.management.propsCategory.fuel': 'Combustible',
  'product.management.propsCategory.treasureBoxKey': 'Llave de Caja del Tesoro',
  'product.management.keyType': 'Tipo de Llave',
  'product.management.keyType.WOOD': 'Llave de Madera',
  'product.management.keyType.IRON': 'Llave de Hierro',
  'product.management.keyType.BRONZE': 'Llave de Bronce',
  'product.management.keyType.SILVER': 'Llave de Plata',
  'product.management.keyType.GOLD': 'Llave de Oro',
  'product.management.keyType.DIAMOND': 'Llave de Diamante',
  'product.management.physical': 'Físico',
  'product.management.enable': 'Habilitar',
  'product.management.disable': 'Deshabilitar',
  'product.management.success': 'Éxito',
  'product.management.fail': 'Falló',
  'product.management.confirmDelete': '¿Está seguro de que desea eliminar?',
  'product.management.confirmEnable': '¿Está seguro de que desea habilitar?',
  'product.management.confirmDisable': '¿Está seguro de que desea deshabilitar?',
  'product.management.operator': 'Operador',
  'product.management.operateTime': 'Hora de Operación',
  'product.management.unknown': 'Desconocido',
  'product.management.unknownStatus': 'Estado Desconocido',
  'product.language.title': 'Gestión de Idiomas',
  'product.language.name': 'Nombre del Producto',
  'product.language.add': 'Añadir Idioma',
  'product.language.edit': 'Editar Idioma',
  'product.language.delete': 'Eliminar',
  'product.language.language': 'Idioma',
  'product.language.image': 'Imagen del Producto',
  'product.language.success': 'Éxito',
  'product.language.fail': 'Falló',
  'product.language.confirmDelete': '¿Está seguro de que desea eliminar?',
  'product.language.operator': 'Operador',
  'product.language.operateTime': 'Hora de Operación',
  'product.stock.title': 'Gestión de Stock',
  'product.stock.name': 'Nombre del Producto',
  'product.stock.add': 'Añadir Stock',
  'product.stock.edit': 'Editar Stock',
  'product.stock.viewHistory': 'Ver Historial',
  'product.stock.available': 'Stock Disponible',
  'product.stock.freeze': 'Stock Congelado',
  'product.stock.total': 'Stock Total',
  'product.stock.changeType': 'Tipo de Movimiento',
  'product.stock.changeAmount': 'Cantidad de Cambio',
  'product.stock.remark': 'Observación',
  'product.stock.history': 'Historial de Cambios',
  'product.stock.increase': 'Aumentar',
  'product.stock.decrease': 'Disminuir',
  'product.stock.success': 'Éxito',
  'product.stock.fail': 'Falló',
  'product.stock.recordNotFound': 'Registro no encontrado',
  'product.stock.operator': 'Operador',
  'product.stock.operateTime': 'Hora de Operación',
  'product.trade.title': 'Registros de Transacciones',
  'product.trade.orderId': 'ID de Canje',
  'product.trade.memberAccount': 'Cuenta de Miembro',
  'product.trade.type': 'Tipo de Producto',
  'product.trade.name': 'Nombre del Producto',
  'product.trade.currency': 'Moneda',
  'product.trade.value': 'Valor del Producto',
  'product.trade.price': 'Puntos del Producto',
  'product.trade.quantity': 'Cantidad Canjeada',
  'product.trade.time': 'Hora del Canje',
  'product.trade.vipLevel': 'Nivel VIP',
  'product.trade.success': 'Éxito',
  'product.trade.fail': 'Falló',
  'product.trade.export': 'Exportar',
  'product.trade.exportWarning': 'Por favor seleccione rango de tiempo',
  'product.trade.exportLoading': 'Exportando datos...',
  'product.trade.exportSuccess': 'Exportación exitosa',
  'product.trade.exportFail': 'Exportación fallida'
};
